<template>
<p class="lead" style="font-weight: 600;">{{ translate('Choose Your Payment Method') }}:</p>
<div>
  <ul class="timeline">
    <li
      v-for="method in paymentMethods"
      :key="method.id"
      @click="selectMethod(method)"
      :class="{ active: selectedMethod && selectedMethod.id === method.id }"
    >
      <i :class="method.icon"></i>
      <div class="timeline-item">
        <h3 class="timeline-header" href="javascript:void(0);">
          <a href="javascript:void(0);">{{ method.name }}</a>
        </h3>
        <slide-up-down class="wobbly-accordion" :duration="500" :active="selectedMethod && selectedMethod.id === method.id">

          <div class="timeline-body">
            <div v-if="method.image" style="float:left;" >
              <img :src="method.image" @click="method.handler()" style="width:90px;margin-top:20px;margin-left:20px;margin-right:10px;">
              <p v-html="method.details" v-if="method.id === 4" style="margin-left:20px"></p>
            </div>
            <div :style="method.id === 3 ? 'padding:0px 0px;' : method.id === 4 ? 'padding:75px 0px;' : 'padding:15px 0px;'">
              <p v-html="method.details" v-if="method.id !== 4"></p>
            </div>
            <!-- Bank Tabs -->
            <div v-if="method.id === 3" class="bank_tabs">
              <b style="color:red;margin-bottom:10px;">- {{ translate('MYR manual topup only available during business hour.') }}</b>
                <div
                  v-for="(bank, index) in bankTabs"
                  :key="bank.id"
                  @click="selectBank(index)"
                  :class="{ 'bank_tab_open': selectedBank === index }"
                >
                  <i class="fa fa-angle-right" :id="'bank' + (index + 1) + '_arrow'" :class="{ rotated: selectedBank === index }">&nbsp;&nbsp;</i>
                  <label class="control-label" :id="bank.id" :data-link="index + 1" name="bank_label" style="padding-bottom:10px;padding-top:10px">{{ bank.name }}</label>
                  
                  <slide-up-down
                    class="wobbly-accordion bank-details"
                    :active="selectedBank === index"
                    :duration="800"
                  >
                    <div class="text-muted gray_box bank-details">
                        <div class="col-sm-6">
                            <b>{{ translate('Bank Account') }}</b><br />
                            {{ translate('Account Name') }}: SMS GURU SDN BHD<br />
                            {{ translate('Account No') }}: {{ bank.accountNo }}<br />
                        </div>
                        <div class="col-sm-6">
                            <b>{{ translate('International Payment') }}</b><br />
                            {{ translate('Bank Add') }}: <span v-html="bank.address"></span><br />
                            SWIFT code: {{ bank.swiftCode }}
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </slide-up-down>
                  
                </div>
              
            </div>
            <!-- END Bank Tabs -->
          </div>
        </slide-up-down>
        
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import VueSlideUpDown from 'vue-slide-up-down';

export default {
  emits: ['method-selected'],
  components: {
    'slide-up-down': VueSlideUpDown
  },
  props: {
    paymentMethods: {
      type: Array,
      required: true,
    },
    canPayDuitNow: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      selectedMethod: null,
      selectedBank: 0, // Default to the first bank (Public Bank)
      lastSelectedBank: 0, // Store the last selected bank for method.id === 3
      bankTabs: [
        {
          id: 'pbe_tab',
          name: 'Public Bank',
          accountNo: '3234436610',
          address: '22 - 26, Jalan 1A/27A, <br />Section 1, Wangsa Maju, <br />53300 Kuala Lumpur, Malaysia.',
          swiftCode: 'PBBEMYKL',
        },
        {
          id: 'hlb_tab',
          name: 'Hong Leong Bank',
          accountNo: '18700064506',
          address: 'No. 2, Jalan Rampai Niaga 1, <br />Rampai Business Park, <br />Taman Sri Rampai, <br />53300 Kuala Lumpur, Malaysia.',
          swiftCode: 'HLBBMYKL',
        },
        {
          id: 'mbb_tab',
          name: 'Malayan Banking Berhad',
          accountNo: '564810540380',
          address: 'No. 2 & 2A, Ground Floor <br />Jalan Wangsa Delima 11, <br />D Wangsa KLSC, Wangsa Maju, <br />53300, Kuala Lumpur, Malaysia.',
          swiftCode: 'MBBEMYKL',
        },
      ],
    };
  },
  watch: { // listens for changes to the canPayDuitNow prop
    paymentMethods(newMethods) {
      if (newMethods && newMethods.length > 0) {
        this.selectMethod(newMethods[0]);
      }
    }
  },
  mounted() {
    // Automatically select the first payment method from the array
    if (this.paymentMethods && this.paymentMethods.length > 0) {
      this.selectMethod(this.paymentMethods[0]);
    }
  },
  methods: {
    selectMethod(method) {
      console.log("canPayDuitNow = " + this.canPayDuitNow);
      if (this.selectedMethod?.id !== method.id) {
        if (this.selectedMethod?.id === 3) {
          // Save the last selected bank when switching away from method 3
          this.lastSelectedBank = this.selectedBank;
        }

        this.selectedMethod = method;

        if (method.id === 3) {
          // Restore the last selected bank when switching back to method 3
          this.selectedBank = this.lastSelectedBank;
        } else {
          this.selectedBank = null; // Reset selected bank if not bank transfer
        }
      }
      this.$emit('method-selected', method); // Emit the selected method
    },
    selectBank(index) {
      if (this.selectedBank !== index) {
        this.selectedBank = index; // Change only if a different bank is selected
      }
    },
    translate(key) {
      return this.$parent.translate(key);
    },
  },
};
</script>
<style>
.timeline>li:before,
.timeline>li:after {
  content: none !important;
}

i.fa-angle-right {
  transition: transform 0.3s ease; /* Smooth transition */
  transform-origin: center; /* Rotate around the center */
  display: inline-block; /* Ensure proper alignment during rotation */
  vertical-align: middle; /* Center the icon vertically */
}

/* Rotated state */
i.fa-angle-right.rotated {
  transform: rotate(90deg);
}


</style>